import React from "react";

import Shop from "../pages/Shop";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home/Home";
import Contact from "../pages/Contact";
import Cart from "../pages/Cart";
import About from "../pages/About";
import SignUp from "../pages/Register/SignUp";
import Login from "../pages/Login/Login";
import Checkout from "../pages/Checkout";
import ForgetPassword from "../pages/Login/ForgetPassword";
import TermsConditions from "../pages/TermsConditions";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import RefundPolicy from "../pages/RefundPolicy";
import Faq from "../pages/Faq";
import SearchPage from "../pages/SearchPage";
import OrderSuccess from "../pages/OrderSuccess/OrderSuccess";
import Profile from "../pages/Profile/MyProfile";
import MyOrders from "../pages/Profile/OrderPage";
import ConfirmOrder from "../pages/ConfirmOrder";
import NotFound from "../pages/NotFound";

const AllRoutes = () => {
  return (
 
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/about" element={<About/>}/>
        <Route path="/register" element={<SignUp/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/checkout" element={<Checkout/>}/>
        <Route path="/forget-password" element={<ForgetPassword/>}/>
        <Route path="/terms-conditions" element={<TermsConditions/>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
        <Route path="/refund-policy" element={<RefundPolicy/>}/>
        <Route path="/faq" element={<Faq/>}/>
        <Route path="/order-success" element={<OrderSuccess/>}/>
        <Route path="/my-profile" element={<Profile/>}/>
        <Route path="/order" element={<MyOrders/>}/>
        <Route path="/search" element={<SearchPage/>}/>
        <Route path="/faqs" element={<Faq/>}/>

        <Route path="*" element={<NotFound />} />
        <Route path="/confirm-order/:order_id" element={<ConfirmOrder />} />
      </Routes>

  );
};

export default AllRoutes;
